<template>
	<div>
		<v-alert v-if="!isLive"
						 border="top"
						 colored-border
						 type="error"
						 elevation="4"
		>
			Der JSON Editor hat <b>keine Stage Umgebung</b>. Alle Änderungen werden auch live deployed.
		</v-alert>
		<h2 class="text-lg-h5 font-weight-bold mb-4">JSON Editor</h2>
		<PublisherSelect store="editor"></PublisherSelect>
		<div class="d-flex flex-row">
			<SiteSelect style="width:400px;" v-model="selectedSite" store="editor"
									hide-add></SiteSelect>
			<SitetypeSelect style="width:400px" v-model="selectedSitetype" store="editor"
											:hide-buttons="true"></SitetypeSelect>
		</div>
		<SiteStatus @intervalStart="siteStatusInterval = $event" store="editor" type="json" class="pb-1"
								:currentIntervalId="siteStatusInterval" :startIntervalEvent="startSiteInterval"></SiteStatus>
		<v-row>
			<v-col>
				<v-tabs v-model="tabIndex" :color="ada.blue" show-arrows>
					<v-tabs-slider :color="ada.blue"></v-tabs-slider>
					<v-tab v-model="tabIndex" flat v-for="tab in tabs" :key="tab.name">
						{{ tab.name }}
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tabIndex" ref="tabContent">
					<v-tab-item
						v-for="tab in tabs"
						:key="tab.name+'_i'"
					>
						<v-card flat class="content_container">
							<v-card-text style="min-height: 20vh;">
								<transition name="fade" mode="out-in">
									<component :type="tab.name" :is="tab.component" :site="selectedSite"
														 :sitetype="selectedSitetype" @click="openEditDialog"
														 @click:add-template="openEditDialog"
														 @click:json-compare="showCodeDiffDialog = true"
														 @click:delete="openDeleteDialog"/>
								</transition>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs-items>
			</v-col>
		</v-row>
		<JsonEditDialog v-model="showEditDialog"
										:type="tabs[tabIndex].name"
										:sitetype="selectedSitetype"
										@submit="openSaveDialog"
										@selectedData="selectedEditData = $event"
										@click:delete="openDeleteDialog"
										@click:json-compare="showCodeDiffDialog = true" :submitDone="submitDone"></JsonEditDialog>
		<JsonCodeDiff v-model="showCodeDiffDialog"></JsonCodeDiff>
		<JsonSaveDialog v-model="saveDialog.show" :type="saveDialog.type"
										:configs.sync="saveDialogConfigs"
										:selectedEditData="selectedEditData"
										@submit="saveMultiple"></JsonSaveDialog>
		<DeleteDialog v-model="showDeleteDialog" :loading="deleteLoading"
									@ok="saveJSON(toBeDeleted.type, toBeDeleted.json, true, null, false, toBeDeleted.description)">
			<div>{{ deleteMessage }}</div>
		</DeleteDialog>
	</div>
</template>

<script>
import PublisherSelect from "../components/PublisherSelect";
import SiteSelect from "../components/SiteSelect";
import SitetypeSelect from "../components/SitetypeSelect";
import ada from "../../scss/ada_colors.scss";
import JsonEditorIndex from "./JsonEditorIndex";
import JsonEditDialog from "./JsonEditDialog";
import axios from "axios";
import DeleteDialog from "../components/DeleteDialog";
import JsonCodeDiff from "./JsonCodeDiff";
import JsonSaveDialog from "./JsonSaveDialog";
import JsonHistory from "./JsonHistory";
import Utils from "../../scripts/Utils";
import SiteStatus from "../components/SiteStatus";

export default {
	name: "JsonEditor",
	components: {
		SiteStatus,
		JsonHistory,
		JsonSaveDialog,
		JsonCodeDiff,
		DeleteDialog, JsonEditDialog, JsonEditorIndex, SitetypeSelect, SiteSelect, PublisherSelect
	},
	data: () => {
		return {
			selectedSite: null,
			selectedSitetype: null,
			saveDialog: {
				show: false,
				type: null,
			},
			saveDialogConfigs: [], //for loading purposes
			showEditDialog: false,
			showDeleteDialog: false,
			showCodeDiffDialog: false,
			toBeDeleted: {
				description: '',
			},
			deleteMessage: '',
			deleteLoading: false,
			tabIndex: 0,
			tabs: [
				{name: 'live', component: 'JsonEditorIndex'},
				{name: 'stage', component: 'JsonEditorIndex'},
				{name: 'history', component: 'JsonHistory'},
			],
			submitDone: 0,
			selectedEditData: null,
			siteStatusInterval: null,
			startSiteInterval: 0,
			ada
		}
	},
	beforeRouteLeave(to, from, next) {
		clearInterval(this.siteStatusInterval);
		this.siteStatusInterval = null;
		next();
	},
	created() {
		window.addEventListener('beforeunload', this.clearSiteStatusInterval);
	},
	mounted() {
		if (this.vuexState.selectedSite) {
			this.selectedSite = this.vuexState.selectedSite;
			this.selectedSitetype = this.vuexState.selectedSitetype;
			this.startSiteInterval++;
		}
		this.$root.$on('inactive', this.clearSiteStatusInterval);
	},
	beforeDestroy() {
		this.$root.$off('inactive', this.clearSiteStatusInterval);
		window.removeEventListener('beforeunload', this.clearSiteStatusInterval);
	},
	computed: {
		url() {
			let base = process.env.NODE_ENV === "development" ? 'http://localhost:3000/' : process.env.VUE_APP_JSON_EDITOR_URL + '/';
			return encodeURI(`${base}?siteId=${this.siteId}&adUnit=${this.adUnit}&name=${this.siteName}:${this.siteTypeName}`);
		},
		vuexState() {
			return this.$store.state.editor;
		},
		adUnit() {
			return this.vuexState.siteDetails ? this.vuexState.siteDetails.Current.AdUnit : '';
		},
		siteName() {
			return this.vuexState.siteDetails ? this.vuexState.siteDetails.Site.Name : '';
		},
		siteId() {
			return this.selectedSite ? this.selectedSite.SiteId : null;
		},
		siteTypeName() {
			return this.selectedSitetype ? this.selectedSitetype.Name : null;
		},
		selectedPublisher() {
			return this.vuexState.selectedPublisher;
		},
		role() {
			return this.$store.state.users.role;
		},
		isLive() {
			return location.origin === 'https://adcontrol.adalliance.io';
		}
	},
	methods: {
		async fetchSiteDetails() {
			this.$store.dispatch('editor/fetchSiteDetails', {siteId: this.selectedSite.SiteId})
		},
		saveMultiple(env, configs, description) {
			this.saveDialogConfigs = JSON.parse(JSON.stringify(configs));
			configs.forEach((config) => {
				this.saveJSON(env, config.new_json, false, config.sitetypeId, true, description);
			})
		},
		saveJSON(env, json = null, deleteLoading = false, sitetypeId = null, multiple = false, description = '') {
			if (deleteLoading) this.deleteLoading = true;
			if (multiple) {
				this.saveDialogConfigs[this.saveDialogConfigs.findIndex(x => x.sitetypeId === sitetypeId)].loading = true;
			}
			let uploadUrl = process.env.NODE_ENV === "development" ? 'http://localhost:3000/api/upload' : process.env.VUE_APP_JSON_EDITOR_URL + '/api/upload';
			let type = typeof env !== "undefined" ? env : this.tabs[this.tabIndex].name;
			if (json === null) {
				json = this.vuexState.finalJson;
			}
			sitetypeId = sitetypeId || this.selectedSitetype.SitetypeId;

			let body = {
				fileName: sitetypeId + '.json',
				json: JSON.stringify(json, null, 1),
				env: type,
				info: {
					description: description,
					//json: JSON.stringify(json).replace(/<br\s\/>|<br>|\s /g, '').replace(/'/g, '"').replace(/"/g, '\\"'),
					json: json,
					site_id: this.selectedSite.SiteId,
					site_name: this.selectedSite.Name,
					sitetype_id: sitetypeId,
					sitetype_name: this.vuexState.siteDetails.Types.find(x => x.SitetypeId === sitetypeId)
						? this.vuexState.siteDetails.Types.find(x => x.SitetypeId === sitetypeId).Name
						: null,
					// eslint-disable-next-line no-undef
					user: sso.getSsoUser().mail
				}
			};

			axios.post(uploadUrl, body, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': process.env.VUE_APP_X_API_KEY
				}
			})
				.then(() => {
					if (this.selectedSitetype.SitetypeId === sitetypeId) {
						this.$store.commit('editor/setJSON', {type: type, payload: json});
					}
					if (this.vuexState.selectedEntry === null && this.vuexState.finalTemplateKey) {
						this.$store.commit('editor/setSelectedEntry', Utils.parseJSONKey(this.vuexState.finalTemplateKey, this.vuexState.types, this.vuexState.teasertypes));
					}
					let msg = Object.keys(json).length !== 0 ?
						(this.deleteLoading ? `Template erfolgreich auf ${type.toUpperCase()} gelöscht` : `${sitetypeId}.json erfolgreich auf ${type.toUpperCase()} deployed`) :
						`${type.toUpperCase()} ${sitetypeId}.json erfolgreich gelöscht.`;
					if (this.showEditDialog && this.showDeleteDialog) this.showEditDialog = false;
					if (this.deleteLoading) this.deleteLoading = false;
					if (this.showDeleteDialog) this.showDeleteDialog = false;
					if (!multiple) this.$root.$emit('snackbar', msg);
					if (multiple) {
						this.saveDialogConfigs[this.saveDialogConfigs.findIndex(x => x.sitetypeId === sitetypeId)].loading = false;
						this.saveDialogConfigs[this.saveDialogConfigs.findIndex(x => x.sitetypeId === sitetypeId)].request = 'success';
						if (this.saveDialogConfigs.map(x => x.loading).every(x => x === false)) {
							if (this.saveDialog.type !== 'copy') {
								msg = `${this.saveDialogConfigs.map(x => x.sitetypeId + '.json').join(', ')} erfolgreich auf ${env.toUpperCase()} deployed`
								this.saveDialog.show = false;
							} else {
								msg = `Template erfolgreich auf ${env.toUpperCase()} ${this.saveDialogConfigs.map(x => x.sitetypeId + '.json').join(', ')}  kopiert. `
							}
							this.$root.$emit('snackbar', msg);
						}
					}
					this.submitDone++;
				}).catch((error) => {
				if (multiple) {
					this.saveDialogConfigs[this.saveDialogConfigs.findIndex(x => x.sitetypeId === sitetypeId)].loading = false;
					this.saveDialogConfigs[this.saveDialogConfigs.findIndex(x => x.sitetypeId === sitetypeId)].request = 'error';
				}
				if (this.deleteLoading) this.deleteLoading = false;
				console.log(error);
			});
		},
		async fetchSiteStatus() {
			if (this.selectedSite && this.$store.state.users.role !== "read") {
				await this.$store.dispatch('display/siteStatus', {
					siteId: this.selectedSite.SiteId,
					type: 'json'
				});
			}
		},
		openEditDialog(entry) {
			this.$store.commit('editor/setSelectedEntry', entry);
			this.showEditDialog = true;
		},
		openSaveDialog(env) {
			this.saveDialog.type = env;
			this.saveDialog.show = true;
		},
		openDeleteDialog(deleteEnv, json, type, key = null) {
			this.deleteMessage = type === 'json' ? `Die komplette ${this.selectedSitetype.SitetypeId}.json löschen?` : `Den Eintrag ${key} wirklich löschen ? `
			this.toBeDeleted.type = deleteEnv;
			this.toBeDeleted.json = json;
			this.toBeDeleted.description = 'Template ' + key + ' gelöscht';
			this.showDeleteDialog = true;
		},
		clearSiteStatusInterval() {
			if (this.siteStatusInterval) {
				clearInterval(this.siteStatusInterval);
			}
		}
	},
	watch: {
		selectedSite() {
			this.$store.commit('editor/setSite', this.selectedSite)
			if (this.selectedSite) {
				this.fetchSiteDetails();
			} else {
				this.$store.commit('editor/setSiteDetails', null);
				this.$store.commit('editor/setJSON', {type: 'stage', payload: null});
				this.$store.commit('editor/setJSON', {type: 'live', payload: null});
				this.$store.commit('editor/setSelectedEntry', null);
			}
		},
		selectedSitetype() {
			this.$store.commit('editor/setSitetype', this.selectedSitetype)
		},
		selectedPublisher() {
			this.selectedSite = null;
			this.selectedSitetype = null;
		},
		siteStatusInterval(n, o) {
			if (o && n !== o) {
				clearInterval(o);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .siteDropdown {
	padding-right: 0 !important;
}
</style>